import { memo, useLayoutEffect } from 'react';
import { gsap, Power1 } from 'gsap';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';

import type { ReactNode } from 'react';

gsap.registerPlugin(DrawSVGPlugin);

interface LineAnimationProps {
	lineId: string;
	children?: ReactNode;
	drawSVG?: string;
	duration: number;
	delay?: number;
	ease?: gsap.TweenVars['ease'];
}

const LineAnimation = ({
	lineId,
	children,
	drawSVG = '0% 0%',
	duration,
	delay,
	ease = Power1.easeIn,
}: LineAnimationProps) => {
	useLayoutEffect(() => {
		const ctx = gsap.context(() => {
			if (delay) {
				gsap.set(lineId, { autoAlpha: 0 });
				gsap.set(lineId, { autoAlpha: 1, delay });
			}
			gsap.from(lineId, { delay, duration, drawSVG, ease });
		});
		return () => ctx.revert();
	}, [delay, drawSVG, duration, ease, lineId]);

	return <>{children}</>;
};

export default memo(LineAnimation);
